import React, { useContext, useEffect, useState } from 'react'
import LoginContext from "../../Context/Logincontext"
import Nav1 from '../../Component/Nav/Nav1'
import { NavLink } from 'react-router-dom'
import "./../../styles/AddProduct.css"
import '../../styles/AddClient.css'
import Swal from 'sweetalert2'
import CloseButton from '../CloseButton'
import LogoComponent from '../LogoComponent'
import { urlApiServer } from '../../Config/Config'

let splitImg = []

const EditSuppliers = (props) => {
    console.log("props: ", props.data)
    const urlPutSuppliers = urlApiServer + "putsuppliers";
    const urlgetConfig = urlApiServer + "getConfig";

    const [name, setName] = useState(props.data?props.data.name:'')
    const [nameCompany, setNameCompany] = useState(props.data?props.data.contact_name:'')
    const [phone, setPhone] = useState(props.data?props.data.phone:'')
    const [mail, setMail] = useState(props.data?props.data.email:'')
    const [address, setAddress] = useState(props.data?props.data.address:'')
    const [country, setCountry] = useState(props.data?props.data.country:'')
    const [city, setCity] = useState(props.data?props.data.city:'')
    const [lastNameOne, setLastNameOne] = useState('')
    const { infoUser, setInfoUser } = useContext(LoginContext)
    const [oldConfig, setOldConfig] = useState("")
    const [logo, setLogo] = useState("")
    // console.log("phone: ", phone)
    // console.log("mail: ", mail)
    // console.log("address: ", address)
    // console.log("country: ", country)
    // console.log("city: ", city)
    // console.log("nameCompany: ", nameCompany)
    // console.log("name: ", name)


    if (lastNameOne === undefined || lastNameOne === '') {
        var fullName = (name !== undefined ? name : '')
    } else {
        var fullName = (name !== undefined ? name : '') + ' ' + (lastNameOne !== undefined ? lastNameOne : '');
    }
    useEffect(() => {
        (async function () {

            const InicioHeaders = new Headers();
            InicioHeaders.append("Content-Type", "application/json")

            const requesoption = {
                method: 'GET',
                headers: InicioHeaders,
                redirect: 'follow'
            }
            await fetch(urlgetConfig, requesoption).then(response => response.json()).then(quotesResponse => {
                setOldConfig(quotesResponse)
            })
        }())
    }, [])

    useEffect(() => {
        if (oldConfig) {
            const foundConfig = oldConfig.find(obj => obj.empresa === infoUser.company);
            if (foundConfig) {
                const { logo } = foundConfig;
                setLogo(logo);
            }
        }
    }, [oldConfig, infoUser])

    if (logo) {
        splitImg = logo.split("|")
    }

    async function handleName(e) {
        const name = e.target.value.replace(/[^A-Z a-z0-9.]/g, "");
        // if (/^[A-Za-z.\s]+$/.test(name) || name === '') {
        setName(name)
        // }
    }

    async function handleNameCompany(e) {
        const name = e.target.value.replace(/[^A-Z a-z0-9.]/g, "");
        // if (/^[A-Za-z.\s]+$/.test(name) || name === '') {
        setNameCompany(name)
        // }
    }

    async function handlePhone(e) {
        let value = e.target.value
        // e.target.value = value;
        setPhone(value);
    }

    async function handleMail(e) {
        let value = e.target.value
        // e.target.value = value;
        setMail(value);
    }

    async function handleAddress(e) {
        let value = e.target.value
        // e.target.value = value;
        setAddress(value);
    }

    async function handleCountry(e) {
        let value = e.target.value
        setCountry(value);
    }

    async function handleCity(e) {
        let value = e.target.value
        setCity(value);
    }

    async function editSupplier() {
        const data = JSON.stringify({
            id: props.data.Id,
            empresa: infoUser.company,
            name: nameCompany,
            contactName: name,
            phone: phone,
            email: mail,
            address: address,
            country: country,
            city: city
        })
        const registerHeaders = new Headers();
        registerHeaders.append("Content-Type", "application/json")

        const requesoption = {
            method: 'PUT',
            headers: registerHeaders,
            body: data,
            redirect: 'follow'
        }

        await fetch(urlPutSuppliers, requesoption).then(response => response.json())
            .then(dataResponse => {
                if (200 === dataResponse.status) {
                    return Swal.fire({
                        icon: 'success',
                        title: '¡Hecho!',
                        text: dataResponse.msj,
                        allowOutsideClick: false,
                        confirmButtonText: 'Aceptar',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            window.location.href = './Proveedores';
                        }
                    })
                }
                if (101 === dataResponse.status) {
                    return Swal.fire({
                        icon: 'error',
                        title: '¡Error!',
                        text: dataResponse.msj,
                        confirmButtonText: 'Aceptar',
                    })
                }
            })

    }

    async function handleBack() {
        props.edit()
    }

    return (
        <>
            {(infoUser.login === true) ? (
                (infoUser.role === 'SuperUsuario') ? (window.location.href = './Crear_Empresa') : (
                    <>
                        <div className="containerHeardANDTable">
                            <div className="HeardANDFilter">
                                <LogoComponent />
                                <div className='containerButtonAdd'>
                                    <div className="navigationContainer">
                                        <div className="pageTitle">EDITAR PROVEEDOR</div>
                                    </div>
                                </div>
                                <div className='closeIntContainer'>
                                    <CloseButton />
                                </div>
                            </div>
                        </div>
                        <div id='overallContainer' className='overallContainer'>
                            <Nav1 />
                            <div className='drawerFormAddCuotes'>
                                <form className='ContainerClient'>
                                    <div className='containerInfoEdit'>
                                        <div className='infoOneEdit'>
                                            <p className='personalInformationEdit'>PROVEEDOR</p>
                                            <div className='containerNameClient'>
                                                <div className="inputClientContainer">
                                                    <input
                                                        type="text"
                                                        value={nameCompany}
                                                        name="Name"
                                                        id="Name"
                                                        onChange={handleNameCompany}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    />
                                                    <label htmlFor="name">Nombre Empresa<em className='Obligatory'>*</em> </label>
                                                </div>

                                                <div className="inputClientContainer">
                                                    <input
                                                        type="text"
                                                        onWheel={(e) => e.target.blur()}
                                                        name="citizenshipCard"
                                                        id="citizenshipCard"
                                                        value={name}
                                                        onChange={handleName}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    />
                                                    <label htmlFor="name">Nombre del Encargado <em className='Obligatory'>*</em> </label>
                                                </div>

                                                <div className="inputClientContainer">
                                                    <input
                                                        type="text"
                                                        onWheel={(e) => e.target.blur()}
                                                        name="citizenshipCard"
                                                        id="citizenshipCard"
                                                        value={phone}
                                                        onChange={handlePhone}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    />
                                                    <label htmlFor="name">Telefono <em className='Obligatory'>*</em> </label>
                                                </div>

                                                <div className="inputClientContainer">
                                                    <input
                                                        type="text"
                                                        onWheel={(e) => e.target.blur()}
                                                        name="citizenshipCard"
                                                        id="citizenshipCard"
                                                        value={mail}
                                                        onChange={handleMail}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    />
                                                    <label htmlFor="name">Email<em className='Obligatory'>*</em> </label>
                                                </div>

                                                <div className="inputClientContainer">
                                                    <input
                                                        type="text"
                                                        onWheel={(e) => e.target.blur()}
                                                        name="citizenshipCard"
                                                        id="citizenshipCard"
                                                        value={address}
                                                        onChange={handleAddress}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    />
                                                    <label htmlFor="name">Direccion<em className='Obligatory'>*</em> </label>
                                                </div>

                                                <div className="inputClientContainer">
                                                    <input
                                                        type="text"
                                                        onWheel={(e) => e.target.blur()}
                                                        name="citizenshipCard"
                                                        id="citizenshipCard"
                                                        value={country}
                                                        onChange={handleCountry}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    />
                                                    <label htmlFor="name">Pais<em className='Obligatory'>*</em> </label>
                                                </div>

                                                <div className="inputClientContainer">
                                                    <input
                                                        type="text"
                                                        onWheel={(e) => e.target.blur()}
                                                        name="citizenshipCard"
                                                        id="citizenshipCard"
                                                        value={city}
                                                        onChange={handleCity}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    />
                                                    <label htmlFor="name">Ciudad<em className='Obligatory'>*</em> </label>
                                                </div>
                                            </div>
                                            <div className="buttonContainerAddClient">
                                                <NavLink className='Textregister' to="/Proveedores" onClick={handleBack}><button className="button neon_Effect"><p>Atras</p></button></NavLink>
                                                <NavLink onClick={editSupplier} className='Textregister'><button className="button neon_Effect"><p>Agregar</p></button></NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </>
                )
            ) : (window.location.href = './Iniciar_Sesión')}
        </>
    )

}

export default EditSuppliers